/**
 * NO03 - Fakturakopi Table Head Component
 * Table header with sortable columns
 */

import { TableHead, TableRow, TableCell, TableSortLabel } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  tableHead: {
    backgroundColor: theme.palette.grey[100],
  },
  headerCell: {
    fontWeight: 600,
    fontSize: '0.82rem',
    padding: '6px 10px',
  },
}));

interface Column {
  id: string;
  label: string;
  align?: 'left' | 'center' | 'right';
  sortable?: boolean;
}

const columns: Column[] = [
  { id: 'kundenr', label: 'Kundenr', sortable: true },
  { id: 'kundenavn', label: 'Kundenavn', sortable: true },
  { id: 'fakturanr', label: 'Fakturanr', sortable: true },
  { id: 'fakturaKid', label: 'Faktura KID', sortable: true },
  { id: 'ordre', label: 'Ordre', sortable: true },
  { id: 'fakturadato', label: 'Fakturadato', sortable: true },
  { id: 'fakturatotal', label: 'Fakturatotal', align: 'right', sortable: true },
  { id: 'actions', label: '', align: 'center', sortable: false },
];

interface NO03TableHeadProps {
  sortBy: string;
  sortDir: 'asc' | 'desc';
  onSort: (columnId: string) => void;
}

export default function NO03TableHead({ sortBy, sortDir, onSort }: NO03TableHeadProps) {
  const { classes } = useStyles();

  return (
    <TableHead className={classes.tableHead}>
      <TableRow>
        {columns.map((column) => (
          <TableCell
            key={column.id}
            align={column.align || 'left'}
            className={classes.headerCell}
          >
            {column.sortable ? (
              <TableSortLabel
                active={sortBy === column.id}
                direction={sortBy === column.id ? sortDir : 'asc'}
                onClick={() => onSort(column.id)}
              >
                {column.label}
              </TableSortLabel>
            ) : (
              column.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
